import { __rest, __read, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useState, useEffect } from 'react';
import { MagnifySearchSolidIcon, CrossSolidIcon } from '@compono/ui-icons';
import { useDebounce } from '../hooks/useDebounce.js';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { TextInput } from '../TextInput/TextInput.js';
import { IconBox } from '../IconBox/index.js';
import { IconButton } from '../IconButton/IconButton.js';

var SearchInput = forwardRef(function SearchInput(_a, ref) {
    var size = _a.size, _b = _a.debounceDelay, debounceDelay = _b === void 0 ? 500 : _b, onClearClick = _a.onClearClick, onChange = _a.onChange, valueProp = _a.value, defaultValue = _a.defaultValue, disabled = _a.disabled, props = __rest(_a, ["size", "debounceDelay", "onClearClick", "onChange", "value", "defaultValue", "disabled"]);
    var _c = __read(useState(valueProp || defaultValue || ""), 2), value = _c[0], setValue = _c[1];
    var _d = __read(useState(false), 2), initialized = _d[0], setInitialized = _d[1];
    var debouncedValue = useDebounce({
        value: value,
        delay: value === "" ? 1 : debounceDelay,
    }).debouncedValue;
    var clearClickHandler = function (e) {
        onClearClick && onClearClick(e);
        if (!e.defaultPrevented) {
            setValue("");
        }
    };
    useEffect(function () {
        if (!initialized) {
            setInitialized(true);
            return;
        }
        onChange && debouncedValue !== undefined && onChange(debouncedValue);
    }, [debouncedValue]);
    useEffect(function () {
        if (initialized) {
            setValue(valueProp || "");
        }
    }, [valueProp]);
    return (jsx(TextInput, __assign({ ref: ref, size: size, value: value, disabled: disabled, onChange: function (e) {
            setValue(e.target.value);
        }, iconLeft: jsx(IconBox, { position: "left", icon: MagnifySearchSolidIcon, themeKey: "inputIcons", title: "Search", size: size }), iconRight: value &&
            !disabled && (jsx(IconButton, __assign({ label: "Clear", size: size, themeKey: "searchClearButton", onClick: clearClickHandler }, { children: jsx(IconBox, { icon: CrossSolidIcon, themeKey: "inputIcons", title: "Clear", size: size, sx: {
                    mx: 0,
                } }) }))) }, props)));
});

export { SearchInput };
//# sourceMappingURL=SearchInput.js.map
